import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check if user is logged in on mount
useEffect(() => {
  const token = localStorage.getItem('token');
  const savedUser = localStorage.getItem('user');

  // ✅ FIX: Add validation before parsing
  if (token && savedUser && savedUser !== 'undefined' && savedUser !== 'null') {
    try {
      setUser(JSON.parse(savedUser));
      // Verify token is still valid
      authAPI.me()
        .then(response => {
          setUser(response.data.user);
          localStorage.setItem('user', JSON.stringify(response.data.user));
        })
        .catch(() => {
          logout();
        })
        .finally(() => setLoading(false));
    } catch (parseError) {
      console.error('Error parsing saved user:', parseError);
      logout();
      setLoading(false);
    }
  } else {
    setLoading(false);
  }
}, []); // ⚠️ Add empty dependency array to prevent infinite loop

  // // Check if user is logged in on mount
  // useEffect(() => {
  //   const token = localStorage.getItem('token');
  //   const savedUser = localStorage.getItem('user');

  //   if (token && savedUser) {
  //     setUser(JSON.parse(savedUser));
  //     // Verify token is still valid
  //     authAPI.me()
  //       .then(response => {
  //         setUser(response.data.user);
  //         localStorage.setItem('user', JSON.stringify(response.data.user));
  //       })
  //       .catch(() => {
  //         logout();
  //       })
  //       .finally(() => setLoading(false));
  //   } else {
  //     setLoading(false);
  //   }
  // }, []);

  const login = async (email, password) => {
    try {
      setError(null);
      const response = await authAPI.login({ email, password });
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      setUser(user);

      return { success: true };
    } catch (err) {
      const errorData = err.response?.data;
      const errorMsg =
        (typeof errorData?.error === 'string' && errorData.error) ||
        (typeof errorData?.message === 'string' && errorData.message) ||
        err.message ||
        'Login failed';
      setError(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setError(null);
  };

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    isAdmin: user?.role === 'admin',
    isEmployee: user?.role === 'employee',
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
